export default {
    data() {
        return {
          swatchPrice: 9.95,
        }
    },
}
